/* Vintedoisk — página "Troca ou devolução" (/pages/solicitar-troca), 25/10/2026.
   Conversa com trocas.vintedoisk.com.br/api/cliente. Sem dependências. */
(function () {
  var raiz = document.getElementById('vkt');
  if (!raiz) return;
  var API = raiz.getAttribute('data-api');
  var $ = function (s, r) { return (r || raiz).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || raiz).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var reais = function (v) { return Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); };
  var dia = function (d) { return d ? new Date(d).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric' }) : ''; };
  var diaHora = function (d) { return new Date(d).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }); };
  var nomeCurto = function (t) { return String(t || '').replace(/\s+\S*\d{4,}\S*(\s+\S+)?$/, '').toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); }); };

  var E = { dados: null, sel: {}, motivo: '', resolucao: '', fotos: {}, desejos: {}, enviando: 0 };

  function chamar(acao, corpo, metodo) {
    var url = API + '?acao=' + acao;
    var op = { method: metodo || 'POST', headers: {} };
    if (metodo === 'GET') url += '&' + new URLSearchParams(corpo).toString();
    else { op.headers['Content-Type'] = 'application/json'; op.body = JSON.stringify(corpo || {}); }
    return fetch(url, op).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.erro || 'Não conseguimos concluir agora. Tente de novo.'); e.dados = j; throw e; }
        return j;
      });
    }, function () { throw new Error('Sem conexão. Confira a internet e tente de novo.'); });
  }
  function carregando(btn, sim) {
    if (sim) { btn.disabled = true; btn.setAttribute('data-t', btn.innerHTML); btn.innerHTML = '<span class="vkt-gira"></span>'; }
    else { btn.disabled = false; if (btn.getAttribute('data-t')) btn.innerHTML = btn.getAttribute('data-t'); }
  }
  function erro(form, msg) { var p = $('.vkt-erro', form); if (p) p.textContent = msg || ''; if (msg) p.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  function irPara(n) {
    $$('.vkt-passo').forEach(function (p) { p.classList.toggle('on', p.id === 'vkt-p' + n); });
    $$('#vkt-etapas li').forEach(function (li) { var e = Number(li.getAttribute('data-e')); li.classList.toggle('on', e === n); li.classList.toggle('feito', e < n); });
    var topo = $('#vkt-etapas').getBoundingClientRect().top + window.scrollY - 120;
    if (window.scrollY > topo) window.scrollTo({ top: topo, behavior: 'smooth' });
  }
  $$('[data-volta]').forEach(function (b) { b.addEventListener('click', function () { irPara(Number(b.getAttribute('data-volta'))); }); });
  // o aviso de erro some assim que a cliente mexe no formulário
  $$('form.vkt-passo').forEach(function (f) { ['input', 'change'].forEach(function (t) { f.addEventListener(t, function () { var p = $('.vkt-erro', f); if (p && p.textContent) p.textContent = ''; }); }); });

  // ---------- 1. pedido ----------
  var f1 = $('#vkt-p1');
  // vindo da conta da cliente ("Trocar ou devolver" no pedido): ?pedido=115478&email=… → busca sozinha
  var autoBusca = false;
  try {
    var u = new URLSearchParams(location.search);
    if (u.get('pedido')) f1.pedido.value = u.get('pedido');
    if (u.get('email')) f1.doc.value = u.get('email');
    autoBusca = !!(u.get('pedido') && u.get('email') && !u.get('protocolo'));
  } catch (e) {}
  // de onde a cliente chegou (vai junto da solicitação; o painel mede qual entrada funciona)
  var origem = 'direto';
  try {
    var q0 = new URLSearchParams(location.search), ref = document.referrer ? new URL(document.referrer) : null;
    if (q0.get('origem')) origem = q0.get('origem');
    else if (q0.get('email')) origem = 'conta';
    else if (q0.get('pedido')) origem = 'whatsapp';
    else if (ref && ref.hostname === location.hostname) {
      var m = ref.pathname.match(/^\/(products|collections|pages|account|cart|search)(?:\/([^\/?#]+))?/);
      origem = !m ? 'home' : m[1] === 'products' ? 'produto' : m[1] === 'pages' ? 'pagina:' + m[2] : m[1];
    } else if (ref) origem = ref.hostname.replace(/^www\./, '');
  } catch (e) {}
  f1.doc.addEventListener('input', function () {
    var v = f1.doc.value;
    if (/^[\d.\-\s]+$/.test(v) && v.replace(/\D/g, '').length <= 11) {
      var d = v.replace(/\D/g, '');
      f1.doc.value = d.replace(/^(\d{3})(\d)/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1-$2');
    }
  });
  f1.addEventListener('submit', function (ev) {
    ev.preventDefault(); erro(f1, '');
    if (!f1.pedido.value.replace(/\D/g, '')) return erro(f1, 'Informe o número do pedido.');
    if (!f1.doc.value.trim()) return erro(f1, 'Informe o CPF ou o e-mail usado na compra.');
    var btn = $('button[type=submit]', f1); carregando(btn, true);
    chamar('consultar', { pedido: f1.pedido.value, doc: f1.doc.value.trim() }).then(function (j) {
      carregando(btn, false);
      if (!j.ok) {
        var extra = j.aberta ? ' <a href="?protocolo=' + encodeURIComponent(j.aberta.protocolo) + '&t=' + encodeURIComponent(j.aberta.token) + '">Ver a solicitação ' + esc(j.aberta.protocolo) + '</a>' : '';
        $('.vkt-erro', f1).innerHTML = esc(j.motivo) + extra; return;
      }
      E.dados = j; E.sel = {}; E.motivo = ''; E.resolucao = ''; E.fotos = {}; E.desejos = {};
      montarPasso2(); irPara(2);
    }, function (e) { carregando(btn, false); erro(f1, e.message); });
  });

  // ---------- 2. peças, motivo, resolução ----------
  function montarPasso2() {
    var d = E.dados, p = d.pedido;
    var fonte = { correios: 'pelo rastreio dos Correios', shopify: '', retirada: 'retirada na loja', estimada: 'data estimada' }[p.entrega_fonte] || '';
    $('#vkt-info').innerHTML = '<span>Pedido <b>' + esc(p.numero) + '</b></span><span>Recebido em <b>' + dia(p.entregue_em) + '</b>' + (fonte ? ' <small>(' + fonte + ')</small>' : '') + '</span>' +
      '<span>' + (p.so_garantia ? 'Prazo de 7 dias encerrado' : 'Pode pedir até <b>' + dia(p.prazo) + '</b>') + '</span><button type="button" class="vkt-trocar" id="vkt-outro">Outro pedido</button>';
    $('#vkt-outro').onclick = function () { irPara(1); };
    var avisos = '';
    (d.abertas || []).forEach(function (a) { avisos += '<p class="vkt-aviso">Você já tem a solicitação <a href="?protocolo=' + encodeURIComponent(a.protocolo) + '&t=' + encodeURIComponent(a.token) + '">' + esc(a.protocolo) + '</a> aberta para este pedido. Aqui aparecem só as peças que ainda podem voltar.</p>'; });
    if (p.so_garantia) avisos += '<p class="vkt-aviso">O prazo de 7 dias para troca ou desistência já terminou. Ainda dá para pedir por <b>defeito</b> (garantia legal) — a equipe analisa caso a caso.</p>';
    $('#vkt-itens').innerHTML = avisos + d.itens.map(function (i) {
      var off = i.quantidade < 1;
      return '<label class="vkt-item' + (off ? ' desligado' : '') + '" data-li="' + i.line_item_id + '"><input type="checkbox" ' + (off ? 'disabled' : '') + ' aria-label="Escolher ' + esc(nomeCurto(i.titulo)) + '">' +
        (i.foto ? '<img src="' + esc(i.foto) + '" alt="" loading="lazy">' : '<span class="vkt-semfoto"></span>') +
        '<span><span class="vkt-item__nome">' + esc(nomeCurto(i.titulo)) + '</span><br><span class="vkt-item__var">' + esc(i.variante) + (off ? ' · já solicitada' : '') + '</span>' +
        (i.quantidade > 1 ? '<br><span class="vkt-qtd" hidden><button type="button" data-q="-1" aria-label="Menos">−</button><span>1</span><button type="button" data-q="1" aria-label="Mais">+</button></span>' : '') + '</span>' +
        '<span class="vkt-item__preco">' + reais(i.valor_unitario) + '</span></label>';
    }).join('');
    $$('.vkt-item').forEach(function (el) {
      var li = el.getAttribute('data-li'), item = itemPorId(li), cb = $('input', el);
      if (!cb || cb.disabled) return;
      cb.addEventListener('change', function () {
        if (cb.checked) E.sel[li] = 1; else delete E.sel[li];
        var q = $('.vkt-qtd', el); if (q) q.hidden = !cb.checked;
        atualizar();
      });
      $$('[data-q]', el).forEach(function (b) {
        b.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation();
          var n = Math.min(item.quantidade, Math.max(1, (E.sel[li] || 1) + Number(b.getAttribute('data-q'))));
          E.sel[li] = n; $('.vkt-qtd span', el).textContent = n; atualizar(); });
      });
    });
    var motivos = d.motivos, chaves = Object.keys(motivos).filter(function (k) { return !p.so_garantia || k === 'defeito'; });
    var dicas = { arrependimento: 'Até 7 dias do recebimento, sem precisar justificar.', tamanho: 'Ficou grande ou pequeno.', modelo: 'A peça não ficou como você imaginava.', defeito: 'Costura, mancha, peça danificada… envie fotos.' };
    $('#vkt-motivos').innerHTML = chaves.map(function (k) {
      return '<label class="vkt-opcao"><input type="radio" name="motivo" value="' + k + '"><span><b>' + esc(motivos[k].nome) + '</b><small>' + esc(dicas[k] || '') + '</small></span></label>';
    }).join('');
    $$('input[name=motivo]').forEach(function (r) { r.addEventListener('change', function () { E.motivo = r.value; E.resolucao = ''; marcarOpcoes(); montarResolucoes(); atualizar(); }); });
    $('#vkt-resolucoes').innerHTML = '<p class="vkt-sub">Escolha o motivo primeiro.</p>';
    atualizar();
  }
  function itemPorId(li) { return E.dados.itens.filter(function (i) { return String(i.line_item_id) === String(li); })[0]; }
  function marcarOpcoes() { $$('.vkt-opcao').forEach(function (o) { o.classList.toggle('on', $('input', o).checked); }); }
  function freteDaCliente() { return ['tamanho', 'modelo'].indexOf(E.motivo) >= 0 && ['troca', 'credito'].indexOf(E.resolucao) >= 0; }
  function montarResolucoes() {
    var d = E.dados, lista = d.motivos[E.motivo].resolucoes;
    var txt = {
      troca: ['Trocar', 'Outro tamanho, cor ou peça, conforme o estoque.'],
      credito: ['Crédito na loja', 'Um cupom no valor pago, para usar quando quiser no site.'],
      reembolso: ['Reembolso', E.motivo === 'arrependimento' ? 'Devolvemos 100% do valor pago, inclusive o frete.' : 'Devolvemos o valor pago, na mesma forma de pagamento.'],
    };
    $('#vkt-resolucoes').innerHTML = lista.map(function (k) {
      var gratis = !(['tamanho', 'modelo'].indexOf(E.motivo) >= 0 && ['troca', 'credito'].indexOf(k) >= 0);
      return '<label class="vkt-opcao"><input type="radio" name="resolucao" value="' + k + '"><span><b>' + txt[k][0] + '</b><small>' + txt[k][1] + '</small>' +
        (gratis ? '<span class="vkt-selo-ok">Frete grátis</span>' : '') + '</span></label>';
    }).join('');
    $$('input[name=resolucao]').forEach(function (r) { r.addEventListener('change', function () { E.resolucao = r.value; marcarOpcoes(); atualizar(); }); });
  }
  function atualizar() {
    var ids = Object.keys(E.sel);
    // fotos (defeito)
    var bf = $('#vkt-fotos-bloco');
    bf.hidden = !(E.motivo === 'defeito' && ids.length);
    if (!bf.hidden) {
      $('#vkt-fotos').innerHTML = ids.map(function (li) {
        var i = itemPorId(li), fs = E.fotos[li] || [];
        return '<div class="vkt-foto-item" data-li="' + li + '"><p>' + esc(nomeCurto(i.titulo)) + ' <span style="color:var(--vk-suave)">· ' + esc(i.variante) + '</span></p><div class="vkt-miniaturas">' +
          fs.map(function (f, k) { return '<div class="vkt-mini-foto' + (f.estado === 'enviando' ? ' enviando' : f.estado === 'erro' ? ' falhou' : '') + '"><img src="' + f.previa + '" alt="Foto ' + (k + 1) + '"><button type="button" data-rm="' + k + '" aria-label="Remover foto">×</button></div>'; }).join('') +
          (fs.length < 5 ? '<label class="vkt-add-foto"><span><b>+</b>Foto</span><input type="file" accept="image/*" multiple></label>' : '') + '</div></div>';
      }).join('');
      $$('.vkt-foto-item').forEach(function (bl) {
        var li = bl.getAttribute('data-li');
        var inp = $('input[type=file]', bl); if (inp) inp.addEventListener('change', function () { adicionarFotos(li, inp.files); });
        $$('[data-rm]', bl).forEach(function (b) { b.addEventListener('click', function () { E.fotos[li].splice(Number(b.getAttribute('data-rm')), 1); atualizar(); }); });
      });
    }
    // troca: pelo quê
    var bd = $('#vkt-desejos-bloco');
    bd.hidden = !(E.resolucao === 'troca' && ids.length);
    if (!bd.hidden) {
      $('#vkt-desejos').innerHTML = ids.map(function (li) {
        var i = itemPorId(li), atual = E.desejos[li] || {};
        var ops = (i.opcoes || []).map(function (o) { return '<option value="' + o.id + '"' + (String(atual.variant) === String(o.id) ? ' selected' : '') + '>' + esc(o.nome) + (Math.abs(o.preco - i.valor_unitario) > 0.01 && o.preco > i.valor_unitario ? ' · ' + reais(o.preco) : '') + '</option>'; }).join('');
        return '<div class="vkt-desejo" data-li="' + li + '">' + (i.foto ? '<img src="' + esc(i.foto) + '" alt="">' : '<span class="vkt-semfoto"></span>') + '<div><p>' + esc(nomeCurto(i.titulo)) + ' · você recebeu <b>' + esc(i.variante) + '</b></p>' +
          '<select aria-label="Trocar por"><option value="">' + (ops ? 'Escolha o tamanho/cor…' : 'Sem outros tamanhos à venda agora') + '</option>' + ops + '<option value="outro"' + (atual.variant === 'outro' ? ' selected' : '') + '>Outra peça (vou descrever)</option></select>' +
          '<input type="text" maxlength="120" placeholder="Qual peça? (nome, cor e tamanho)"' + (atual.variant === 'outro' ? '' : ' hidden') + ' value="' + esc(atual.texto || '') + '"></div></div>';
      }).join('');
      $$('.vkt-desejo').forEach(function (bl) {
        var li = bl.getAttribute('data-li'), s = $('select', bl), t = $('input', bl);
        s.addEventListener('change', function () { E.desejos[li] = { variant: s.value, nome: s.value && s.value !== 'outro' ? s.options[s.selectedIndex].text.split(' · ')[0] : '', texto: t.value }; t.hidden = s.value !== 'outro'; if (!t.hidden) t.focus(); });
        t.addEventListener('input', function () { E.desejos[li] = Object.assign(E.desejos[li] || {}, { texto: t.value }); });
      });
    }
    // frete
    var fr = $('#vkt-frete');
    if (E.resolucao && ids.length) {
      fr.hidden = false;
      if (freteDaCliente()) {
        var est = E.dados.frete_estimado;
        fr.innerHTML = 'O frete da volta é por sua conta' + (est ? ' (cerca de <b>' + reais(est) + '</b> pelo nosso contrato com os Correios)' : '') + '. ' +
          (E.resolucao === 'credito' ? 'Ele é descontado do seu crédito — você não paga nada na agência.' : 'Ele é cobrado junto com o envio da peça nova (' + reais(E.dados.frete_reenvio) + ') — você não paga nada na agência.');
      } else fr.innerHTML = '<b>Frete grátis:</b> a postagem nos Correios fica por nossa conta.';
    } else fr.hidden = true;
  }

  // fotos: reduz no aparelho (máx. 1600 px, JPEG) e sobe direto para o armazenamento por URL assinada
  function reduzir(arq) {
    return new Promise(function (ok) {
      if (!/^image\/(jpeg|png|webp)$/.test(arq.type) || !window.createImageBitmap) return ok(arq);
      createImageBitmap(arq).then(function (bmp) {
        var m = 1600, k = Math.min(1, m / Math.max(bmp.width, bmp.height));
        var c = document.createElement('canvas'); c.width = Math.round(bmp.width * k); c.height = Math.round(bmp.height * k);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        c.toBlob(function (b) { ok(b && b.size < arq.size ? new File([b], 'foto.jpg', { type: 'image/jpeg' }) : arq); }, 'image/jpeg', 0.85);
      }, function () { ok(arq); });
    });
  }
  function adicionarFotos(li, lista) {
    var arr = E.fotos[li] = E.fotos[li] || [];
    Array.prototype.slice.call(lista, 0, 5 - arr.length).forEach(function (arq) {
      if (arq.size > 25 * 1024 * 1024) return alert('Foto muito grande (máx. 25 MB).');
      var f = { estado: 'enviando', previa: URL.createObjectURL(arq), caminho: null };
      arr.push(f); E.enviando++;
      reduzir(arq).then(function (a) {
        return chamar('foto', { ticket: E.dados.ticket, tipo: a.type }).then(function (j) {
          return fetch(j.url, { method: 'PUT', headers: { 'Content-Type': a.type || 'image/jpeg', 'x-upsert': 'false' }, body: a }).then(function (r) {
            if (!r.ok) throw new Error('envio ' + r.status); f.caminho = j.caminho; f.estado = 'ok';
          });
        });
      }).catch(function () { f.estado = 'erro'; }).then(function () { E.enviando--; atualizar(); });
    });
    atualizar();
  }

  var f2 = $('#vkt-p2');
  f2.addEventListener('submit', function (ev) {
    ev.preventDefault(); erro(f2, '');
    var ids = Object.keys(E.sel);
    if (!ids.length) return erro(f2, 'Escolha pelo menos uma peça.');
    if (!E.motivo) return erro(f2, 'Escolha o motivo.');
    if (E.motivo === 'defeito') {
      if (E.enviando) return erro(f2, 'Espere as fotos terminarem de enviar.');
      for (var k = 0; k < ids.length; k++) {
        var fs = (E.fotos[ids[k]] || []).filter(function (f) { return f.estado === 'ok'; });
        if (!fs.length) return erro(f2, 'Envie pelo menos uma foto do defeito de cada peça.');
        if ((E.fotos[ids[k]] || []).some(function (f) { return f.estado === 'erro'; })) return erro(f2, 'Uma foto não enviou (marcada em vermelho). Remova e tente de novo.');
      }
    }
    if (!E.resolucao) return erro(f2, 'Escolha como prefere resolver.');
    if (E.resolucao === 'troca') {
      for (var j = 0; j < ids.length; j++) {
        var dz = E.desejos[ids[j]] || {};
        if (!dz.variant || (dz.variant === 'outro' && !String(dz.texto || '').trim())) return erro(f2, 'Diga pelo que quer trocar cada peça.');
      }
    }
    montarPasso3(); irPara(3);
  });

  // ---------- 3. dados ----------
  var f3 = $('#vkt-p3');
  var mascTel = function (v) { var d = String(v || '').replace(/\D/g, '').replace(/^55(?=\d{10,11}$)/, '').slice(0, 11); return d.length > 6 ? '(' + d.slice(0, 2) + ') ' + d.slice(2, d.length - 4) + '-' + d.slice(-4) : d.length > 2 ? '(' + d.slice(0, 2) + ') ' + d.slice(2) : d; };
  f3.telefone.addEventListener('input', function () { f3.telefone.value = mascTel(f3.telefone.value); });
  f3.cep.addEventListener('input', function () {
    var d = f3.cep.value.replace(/\D/g, '').slice(0, 8);
    f3.cep.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
    if (d.length === 8 && d !== f3.cep.getAttribute('data-ultimo')) {
      f3.cep.setAttribute('data-ultimo', d);
      fetch('https://viacep.com.br/ws/' + d + '/json/').then(function (r) { return r.json(); }).then(function (j) {
        if (j.erro) return;
        if (j.logradouro) f3.logradouro.value = j.logradouro;
        if (j.bairro) f3.bairro.value = j.bairro;
        f3.cidade.value = j.localidade || f3.cidade.value; f3.uf.value = j.uf || f3.uf.value;
        (j.logradouro ? f3.numero : f3.logradouro).focus();
      }).catch(function () {});
    }
  });
  function montarPasso3() {
    var c = E.dados.cliente, e = c.endereco || {};
    if (!f3.getAttribute('data-ok')) {
      f3.telefone.value = mascTel(c.telefone); f3.email.placeholder = c.tem_email ? c.email_mascara + ' (o da compra)' : 'seu@email.com';
      f3.cep.value = String(e.cep || '').replace(/^(\d{5})(\d{3})$/, '$1-$2'); f3.cep.setAttribute('data-ultimo', e.cep || '');
      ['logradouro', 'numero', 'complemento', 'bairro', 'cidade', 'uf'].forEach(function (k) { f3[k].value = e[k] || ''; });
      f3.setAttribute('data-ok', '1');
    }
    var ids = Object.keys(E.sel), mot = E.dados.motivos[E.motivo].nome, res = E.dados.resolucoes[E.resolucao];
    $('#vkt-resumo').innerHTML = '<h4>Resumo</h4>' + ids.map(function (li) {
      var i = itemPorId(li), dz = E.desejos[li];
      return '<p>' + E.sel[li] + '× ' + esc(nomeCurto(i.titulo)) + ' · ' + esc(i.variante) + (E.resolucao === 'troca' && dz ? ' → <b>' + esc(dz.variant === 'outro' ? dz.texto : dz.nome) + '</b>' : '') + '</p>';
    }).join('') + '<p style="margin-top:1rem!important">' + esc(mot) + ' · <b>' + esc(res) + '</b>' + (freteDaCliente() ? ' · frete da volta por sua conta' : ' · frete grátis') + '</p>';
  }
  f3.addEventListener('submit', function (ev) {
    ev.preventDefault(); erro(f3, '');
    var tel = f3.telefone.value.replace(/\D/g, '');
    if (tel.length !== 11 || tel[2] !== '9') return erro(f3, 'Informe um celular com WhatsApp e DDD — é por ele que mandamos o código de postagem.');
    if (f3.email.value && !/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(f3.email.value.trim())) return erro(f3, 'Confira o e-mail.');
    if (!E.dados.cliente.tem_email && !f3.email.value.trim()) return erro(f3, 'Informe um e-mail.');
    var faltando = ['cep', 'logradouro', 'numero', 'bairro', 'cidade', 'uf'].filter(function (k) { var x = f3[k]; var ruim = !x.value.trim() || (k === 'cep' && x.value.replace(/\D/g, '').length !== 8); x.classList.toggle('vkt-invalido', ruim); return ruim; });
    if (faltando.length) return erro(f3, 'Confira o endereço de onde a peça vai sair.');
    if (!f3.aceite.checked) return erro(f3, 'Confirme as condições da peça para continuar.');
    var ids = Object.keys(E.sel);
    var corpo = {
      ticket: E.dados.ticket, motivo: E.motivo, resolucao: E.resolucao, comentario: $('textarea[name=comentario]', f2).value, aceite: true,
      telefone: tel, email: f3.email.value.trim(), origem: origem,
      endereco: { cep: f3.cep.value, logradouro: f3.logradouro.value, numero: f3.numero.value, complemento: f3.complemento.value, bairro: f3.bairro.value, cidade: f3.cidade.value, uf: f3.uf.value },
      itens: ids.map(function (li) {
        var dz = E.desejos[li] || {};
        return { line_item_id: li, quantidade: E.sel[li],
          fotos: (E.fotos[li] || []).filter(function (f) { return f.estado === 'ok'; }).map(function (f) { return f.caminho; }),
          desejo_variant_id: E.resolucao === 'troca' && dz.variant && dz.variant !== 'outro' ? dz.variant : null,
          desejo: E.resolucao === 'troca' ? (dz.variant === 'outro' ? dz.texto : dz.nome) : null };
      }),
    };
    var btn = $('button[type=submit]', f3); carregando(btn, true);
    chamar('solicitar', corpo).then(function (j) {
      try { history.replaceState(null, '', '?protocolo=' + j.protocolo + '&t=' + j.token); } catch (e) {}
      mostrarStatus(j.protocolo, j.token, true);
    }, function (e) {
      carregando(btn, false);
      if (e.dados && e.dados.expirou) { erro(f3, e.message); setTimeout(function () { irPara(1); }, 1800); return; }
      erro(f3, e.message);
    });
  });

  // ---------- 4. andamento ----------
  var TRILHO = [['solicitada', 'Solicitada'], ['aprovada', 'Aprovada'], ['postada', 'Postada'], ['recebida', 'Na loja'], ['concluida', 'Concluída']];
  var ORDEM = { solicitada: 0, aprovada: 1, postada: 2, recebida: 3, aguardando_pagamento: 3, concluida: 4 };
  function mostrarStatus(protocolo, token, recemCriada) {
    var box = $('#vkt-p4');
    box.innerHTML = '<p class="vkt-sub">Carregando…</p>';
    irPara(4);
    chamar('status', { protocolo: protocolo, t: token }, 'GET').then(function (s) {
      var pos = ORDEM[s.status], fechada = pos === undefined;
      var tom = s.status === 'concluida' ? 'ok' : fechada ? '' : s.status === 'solicitada' || s.status === 'aguardando_pagamento' ? 'alerta' : '';
      var h = '';
      if (recemCriada) h += '<h2 class="vkt-h2">Recebemos a sua solicitação 💛</h2><p class="vkt-sub">Guarde o protocolo. A equipe vai analisar e responder no seu WhatsApp em até 1 dia útil. <strong>Não envie a peça ainda</strong> — o código de postagem chega depois da aprovação.</p>';
      else h += '<h2 class="vkt-h2">Sua solicitação</h2>';
      h += '<div class="vkt-status-topo"><span class="vkt-protocolo">Protocolo ' + esc(s.protocolo) + ' · pedido ' + esc(s.pedido) + '</span><span class="vkt-badge ' + tom + '">' + esc(s.status_nome) + '</span></div>';
      if (!fechada) h += '<ol class="vkt-trilho">' + TRILHO.map(function (t, k) { return '<li class="' + (k <= pos ? 'feito' : '') + (k === pos ? ' atual' : '') + '">' + t[1] + '</li>'; }).join('') + '</ol>';
      if (s.correios && ['aprovada'].indexOf(s.status) >= 0) {
        h += '<div class="vkt-codigo"><small>Código de postagem dos Correios · ' + esc(s.correios.servico) + '</small><strong id="vkt-cod">' + esc(s.correios.codigo) + '</strong>' +
          '<button type="button" class="vkt-copiar" id="vkt-copiar">Copiar código</button>' +
          '<ol><li>Embale a peça com a etiqueta da marca presa (de preferência na embalagem original).</li><li>Leve a qualquer agência dos Correios até <b>' + dia(s.correios.validade) + '</b> e informe o código no balcão.</li><li>A postagem já está paga — você não paga nada e não precisa imprimir etiqueta. Guarde o comprovante.</li></ol></div>';
      } else if (s.correios && ['postada', 'recebida'].indexOf(s.status) >= 0) {
        h += '<p>Rastreio da sua postagem: <a href="https://rastreamento.correios.com.br/app/index.php?objetos=' + encodeURIComponent(s.correios.codigo) + '" target="_blank" rel="noopener">' + esc(s.correios.codigo) + '</a></p>';
      }
      var c = s.conclusao;
      if (c && c.tipo === 'credito' && c.cupom) h += '<div class="vkt-concluida">Seu crédito: cupom <strong>' + esc(c.cupom) + '</strong> de <b>' + reais(c.valor) + '</b>, válido até ' + dia(c.ate) + '. Use no carrinho em uma compra no site.</div>';
      if (c && c.tipo === 'reembolso') h += '<div class="vkt-concluida">Reembolso de <b>' + reais(c.valor) + '</b> feito na forma de pagamento da compra.</div>';
      if (c && c.tipo === 'troca' && c.link) h += '<div class="vkt-concluida" style="background:var(--vkt-alerta-f)">A peça nova está separada. Falta concluir o pagamento: <a href="' + esc(c.link) + '">pagar agora</a>.</div>';
      if (s.motivo_recusa) h += '<p class="vkt-aviso">' + esc(s.motivo_recusa) + '</p>';
      h += '<div class="vkt-resumo"><h4>Peças</h4>' + s.itens.map(function (i) { return '<p>' + i.quantidade + '× ' + esc(nomeCurto(i.titulo)) + ' · ' + esc(i.variante) + (i.desejo ? ' → <b>' + esc(i.desejo) + '</b>' : '') + '</p>'; }).join('') +
        '<p style="margin-top:1rem!important">' + esc(s.motivo) + ' · <b>' + esc(s.resolucao) + '</b></p></div>';
      h += '<div class="vkt-tempo"><h3>Histórico</h3>' + s.eventos.map(function (v) { return '<div class="vkt-ev"><time>' + diaHora(v.criado_em) + '</time><span>' + esc(v.texto) + '</span></div>'; }).join('') + '</div>';
      h += '<div class="vkt-acoes" style="justify-content:flex-start;gap:2.4rem">' + (s.pode_cancelar ? '<button type="button" class="vkt-voltar" id="vkt-cancelar">Cancelar solicitação</button>' : '') +
        '<a class="vkt-voltar" href="https://wa.me/5515998454099?text=' + encodeURIComponent('Olá! Sobre a minha troca/devolução ' + s.protocolo) + '" target="_blank" rel="noopener">Falar no WhatsApp</a>' +
        '<a class="vkt-voltar" href="/pages/solicitar-troca">Nova solicitação</a></div>';
      box.innerHTML = h;
      var cp = $('#vkt-copiar');
      if (cp) cp.onclick = function () { var t = $('#vkt-cod').textContent; (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () { cp.textContent = 'Copiado ✓'; }, function () { var r = document.createRange(); r.selectNode($('#vkt-cod')); getSelection().removeAllRanges(); getSelection().addRange(r); }); };
      var cc = $('#vkt-cancelar');
      if (cc) cc.onclick = function () {
        if (!confirm('Cancelar esta solicitação?' + (s.correios ? ' O código de postagem deixa de valer.' : ''))) return;
        chamar('cancelar', { protocolo: s.protocolo, t: token }).then(function () { mostrarStatus(protocolo, token); }, function (e) { alert(e.message); });
      };
      $$('#vkt-etapas li').forEach(function (li) { li.classList.add('feito'); li.classList.remove('on'); });
    }, function (e) {
      box.innerHTML = '<h2 class="vkt-h2">Não encontramos essa solicitação</h2><p class="vkt-sub">' + esc(e.message) + ' Confira o link ou fale com a gente no WhatsApp.</p><a class="vk-pg-botao" href="/pages/solicitar-troca">Fazer uma solicitação</a>';
    });
  }

  try {
    var q = new URLSearchParams(location.search);
    if (q.get('protocolo') && q.get('t')) mostrarStatus(q.get('protocolo'), q.get('t'));
    else if (autoBusca) f1.requestSubmit ? f1.requestSubmit() : f1.dispatchEvent(new Event('submit', { cancelable: true }));
  } catch (e) {}
})();
